import type { CurrencyCode } from '@/lib/money'

export interface AccountOption {
  readonly currency: CurrencyCode
  readonly label: string
  readonly rail: string
  readonly note: string
}

export const ACCOUNT_OPTIONS: readonly AccountOption[] = [
  { currency: 'USD', label: 'US Dollar', rail: 'Routing · ACH', note: 'Where salary and transfers land' },
  { currency: 'MXN', label: 'Mexican Peso', rail: 'CLABE · SPEI', note: 'Arrives in minutes' },
  { currency: 'COP', label: 'Colombian Peso', rail: 'Local ACH', note: 'Same day' },
  { currency: 'BRL', label: 'Brazilian Real', rail: 'PIX key · TED', note: 'Arrives in minutes' },
  { currency: 'BOB', label: 'Boliviano', rail: 'Bank transfer', note: 'Next day' },
  { currency: 'EUR', label: 'Euro', rail: 'IBAN · SEPA', note: 'For work in Europe' },
]

export interface CardOption {
  readonly id: 'virtual' | 'physical' | 'agent' | 'both'
  readonly title: string
  readonly price: string
  readonly body: string
  readonly icon: string
}

export const CARD_OPTIONS: readonly CardOption[] = [
  {
    id: 'virtual',
    title: 'Virtual card',
    price: '$9 once',
    body: 'Ready in seconds, for online payments. Wallets need the physical card.',
    icon: 'smartphone',
  },
  {
    id: 'physical',
    title: 'Physical card',
    price: '$50 once',
    body: 'Arrives in about a week. ATMs, contactless, and all three phone wallets.',
    icon: 'credit_card',
  },
  {
    id: 'agent',
    title: 'Agent card',
    price: 'Free',
    body: 'For an AI agent to spend on your behalf, inside limits you set.',
    icon: 'smart_toy',
  },
  {
    id: 'both',
    title: 'Both',
    price: '$55 once',
    body: 'Start spending today and keep the plastic for cash and travel. Saves $4.',
    icon: 'layers',
  },
]
